import React from "react";
import { NotificationAudience } from "../../deals/api/useDeals";

export const AUDIENCE_OPTIONS: { value: NotificationAudience; label: string; description: string }[] = [
  { value: "bell", label: "Bell subscribers", description: "Users who follow this venue" },
  { value: "checked_in", label: "Checked-in users", description: "Users currently checked in" },
  { value: "live", label: "Live users", description: "Users with an active live check-in" },
  { value: "nearby", label: "Nearby users", description: "Users near the venue right now" },
];

export function AudienceSelector({
  selected,
  onChange,
}: {
  selected: NotificationAudience[];
  onChange: (next: NotificationAudience[]) => void;
}) {
  const toggle = (value: NotificationAudience) => {
    if (selected.includes(value)) onChange(selected.filter(v => v !== value));
    else onChange([...selected, value]);
  };
  return (
    <div className="space-y-2">
      {AUDIENCE_OPTIONS.map(opt => {
        const isOn = selected.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => toggle(opt.value)}
            className={`w-full text-left flex items-start gap-3 p-3 border rounded-xl transition-all ${
              isOn
                ? "bg-violet-950/40 border-violet-700 text-white"
                : "bg-gray-800 border-gray-700 text-gray-300 hover:border-gray-600"
            }`}
          >
            <span className={`mt-0.5 w-4 h-4 flex-shrink-0 rounded border flex items-center justify-center ${isOn ? "bg-violet-600 border-violet-500" : "border-gray-600"}`}>
              {isOn && (
                <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
              )}
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium">{opt.label}</p>
              <p className="text-xs text-gray-500 mt-0.5">{opt.description}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
